import { API } from '@ospace/shared'

const listProductLines = async () => {
  return API.get('client', `/product-lines/list`, {})
}

export const ProductService = {
  listProductLines,
}
